import React, {useContext, useEffect} from "react";
import {GlobalContext} from "../admin-frame/AdminFrame";
import {useRenderableData} from "../common/hooks/useRenderableData";
import {MessageDisplayerUtility} from "../common/MessageDisplayerUtility";
import {LeaveWithoutSavingWarningUtility} from "../common/LeaveWithoutSavingWarningUtility";
import {ApiUtility} from "../common/ApiUtility";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {FpServicesForm} from "./FpServicesForm";

export const UpdateFpServices = function (props) {
    const context = useContext(GlobalContext);
    const renderableData = useRenderableData({loading: true});

    useEffect(function () {
        renderableData.updateAndRender({
            fpServices: null,
            loading: true
        })
        ApiUtility.getFpServicesForType(props.fpServiceTypeId)
            .then(function (fpServices) {
                renderableData.updateAndRender({
                    fpServices: fpServices,
                    loading: false,
                });
            })
            .catch(function (error) {
                renderableData.updateAndRender({loading: false});
                console.log(`Error fetching QBO accounts for service type: `, error);
                MessageDisplayerUtility.error(`Error fetching QBO accounts for service type.`);
            });
    }, [props.fpServiceTypeId]);

    function save(formModelData) {
        renderableData.updateAndRender({loading: true})
        ApiUtility.updateFpServicesForType(formModelData, props.fpServiceTypeId)
            .then((response) => {
                renderableData.updateAndRender({loading: false})
                LeaveWithoutSavingWarningUtility.disableLeaveWithoutSavingWarnings(context);
                MessageDisplayerUtility.success(`Successfully updated FP services.`);
            })
            .catch((err) => {
                renderableData.updateAndRender({loading: false});
                console && console.error(err);
                MessageDisplayerUtility.error(`An error occurred while updating the FP services.`);
            });
    }

    return (
        <div className="sub-form-container fp-services-form-container">
            <ConditionalRenderer if={renderableData.loading} renderer={() => (
                <div className="sub-form-loading-indicator-container">
                    <OverlayLoadingIndicator/>
                </div>
            )}/>
            <div className="sub-form-header">
                <div className="sub-form-header-content">
                    <div className="sub-form-header-text">
                        Set QBO accounts for individual FP services
                    </div>
                    <div className="sub-form-header-sub-text">
                        (These override the defaults set above.)<br/>
                        (These are defined separately from the similar settings in FP.)
                    </div>
                </div>
            </div>
            <div className="sub-form">
                <ConditionalRenderer if={renderableData.fpServices} renderer={() => (
                    <FpServicesForm
                        cancel={props.cancel}
                        save={save}
                        fpServices={renderableData.fpServices}
                        fpServiceTypeId={props.fpServiceTypeId}
                        fpServiceTypes={props.fpServiceTypes}
                    />
                )}/>
            </div>
        </div>
    )
}
